import React from 'react';
import { Container, Typography, useTheme } from '@mui/material';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { ImageToSVGConverter } from '../components/ImageToSVGConverter';

export const FreeToolsPage: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { currentLang } = useLanguage();
  const isRTL = currentLang === 'he';

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h3"
          component="div"
          gutterBottom
          sx={{
            fontWeight: 700,
            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary?.main || theme.palette.primary.dark})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textAlign: isRTL ? 'right' : 'left',
            mb: 4,
          }}
        >
          {t('pages.freeTools.title')}
        </Typography>

        <Typography
          variant="body1"
          component="div"
          sx={{
            mb: 4,
            color: 'text.secondary',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
            unicodeBidi: 'plaintext',
          }}
        >
          {t('pages.freeTools.description')}
        </Typography>

        <ImageToSVGConverter />
      </motion.div>
    </Container>
  );
};

